<template>
  <q-page class="container" padding>
    <PageHeader
      title="Cadastrar Área"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <div>
      <q-form ref="myForm">
        <div class="row col-12 q-col-gutter-sm text-brand-5 text-weight-bold">
          <div class="col-md-3 col-sm-12 col-xs-12">
            Unidade:
            <lista-unidades-select
              class="input-new-design"
              :todos="temPermissaoTodasUnidades"
              v-model="emitir.unidade"
            ></lista-unidades-select>
          </div>

          <div class="col-1 col-md-2 col-sm-12 col-xs-12">
            <p></p>
            <q-btn
              class="q-mt-sm full-width"
              label="Criar Área"
              no-caps
              style="
                background-color: #21324a;
                border-radius: 8px;
                color: white;
              "
              icon="add"
              @click="abrirModalCriar"
            />
          </div>
        </div>
      </q-form>
    </div>

    <div>
      <div class="q-mt-lg">
        <!-- Modal: usuário sem permissão e sem unidade selecionada -->
        <dialog-info-design
          mensagem="Selecione uma Unidade para continuar"
          sub-mensagem="Por favor, selecione uma Unidade no filtro antes de prosseguir."
          :exibir="modalSelecioneUnidade"
          :esconder-confirme="true"
          :show-cancelar="true"
          @resultado="modalSelecioneUnidade = false"
        />

        <template v-if="temPermissaoTodasUnidades || emitir.unidade?.id">
          <q-table
            class="q-mt-sm tabela-tamanho-fixo"
            flat
            table-header-class="bg-accent text-width-bold"
            :rows="listaArea"
            dense
            :loading="disable"
            :columns="columns"
            :rows-per-page-options="[0]"
          >
            <template v-slot:no-data="props">
              <div
                v-if="props"
                style="background-color: transparent"
                class="full-width row flex-center q-gutter-sm q-mt-sm"
              >
                <q-img
                  src="./../../../../assets/tabelSemDados.svg"
                  style="height: 170px; width: 150px"
                />
              </div>
            </template>
            <template v-slot:top-left>
              <span
                style="
                  font-size: 16px;
                  display: block;
                  margin-left: -15px;
                  color: #21324a;
                "
                >Áreas Cadastradas.</span
              >
            </template>

            <template v-slot:body="props">
              <q-tr :props="props">
                <q-td class="text-left" key="unidadeId" :props="props">
                  {{ emitir.unidade?.nome || "Sem unidade" }}
                </q-td>
                <q-td class="text-left" key="nome" :props="props">
                  {{ props.row.nome }}
                </q-td>
                <q-td class="center" key="remover" :props="props">
                  <q-btn
                    icon="sym_o_delete"
                    color="red"
                    flat
                    no-caps
                    @click="
                      (deteleId = props.row.areaId),
                        (confirmacao = !confirmacao)
                    "
                  />
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </template>
      </div>
    </div>

    <ModalLateral
      :rightDrawerOpen="rightDrawerOpen"
      :nomeModal="'Cadastrar Área'"
      @fecharModal="rightDrawerOpen = false"
    >
      <template v-slot:conteudo-modal>
        <div class="col-md-12 col-sm-12 col-xs-12 q-mt-sm">
          <div class="q-ml-sm texto-titulo-input">Unidade</div>
          <lista-unidades-select
            class="input-new-design"
            :todos="temPermissaoTodasUnidades"
            v-model="emitir.unidade"
          ></lista-unidades-select>
        </div>

        <div class="col-md-12 col-sm-12 col-xs-12 q-mt-sm">
          <div class="q-ml-sm texto-titulo-input">Nome da área</div>
          <q-input
            dense
            class="input-new-design"
            outlined
            v-model="modalArea.nome"
            label="Digite o nome da área que deseja cadastrar"
          >
          </q-input>
        </div>
      </template>
      <template v-slot:botao-modal>
        <div class="row col-12 q-gutter-sm">
          <q-btn
            no-caps
            label="Criar"
            class="btn-modal"
            icon="done"
            color="positive"
            @click="criar"
          />
        </div>
      </template>
    </ModalLateral>

    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>

    <dialog-confirm-design
      mensagem="Tem certeza que deseja excluir Área?"
      :exibir="confirmacao"
      @resultado="removerArea"
    />
  </q-page>
</template>

<script>
import { onMounted, watch, computed } from "vue";
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import ModalLateral from "../../../../components/ModalLateral.vue";
import { usuarioTemPermissao } from "../../../../helpers/permissaoHelper";
import PageHeader from "../../../../components/PageHeader.vue";

export default {
  components: {
    DialogConfirmDesign,
    DialogInfoDesign,
    ListaUnidadesSelect,
    ModalLateral,
    PageHeader,
  },
  name: "CadastrarArea",
  setup() {
    const emitir = ref({
      unidade: "",
      local: "",
      descricao: "",
      dataInicio: new Date().toLocaleString("pt-br"),
      dataTermino: new Date().toLocaleString("pt-br"),
    });
    const area = ref({
      areaId: "",
      unidadeId: "",
      nome: "",
    });

    const modalArea = ref({
      unidade: "",
      nome: "",
    });

    const rightDrawerOpen = ref(false);
    const disable = ref(false);
    const confirmacao = ref(false);
    const listaArea = ref([]);
    const deteleId = ref(null);
    const modalSelecioneUnidade = ref(false);
    const $q = useQuasar();
    const myForm = ref(null);
    const store = useStore();

    const temPermissaoTodasUnidades = computed(() =>
      usuarioTemPermissao(store, "visualizar_todas_unidades")
    );

    const columns = [
      {
        name: "unidadeId",
        label: "Nome Unidade",
        field: "unidadeId",
        align: "left",
        sortable: true,
      },
      {
        name: "nome",
        label: "Nome Área",
        field: "nome",
        align: "left",
        sortable: true,
      },
      {
        name: "remover",
        label: "Excluir",
        align: "center",
      },
    ];

    const abrirModalCriar = () => {
      if (!temPermissaoTodasUnidades.value && !emitir.value.unidade?.id) {
        modalSelecioneUnidade.value = true;
        return;
      }
      rightDrawerOpen.value = true;
    };

    let listarArea = async () => {
      if (!temPermissaoTodasUnidades.value && !emitir.value.unidade?.id) {
        return;
      }

      disable.value = true;
      try {
        let resposta = await store.dispatch("area/listar", {
          unidadeId: emitir.value.unidade.id,
        });

        listaArea.value = resposta.listaArea;
        disable.value = false;
      } catch (error) {
        console.error(error);
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        emitir.value.unidade = store.state.org.unidadeData;
        modalArea.value.unidade = store.state.org.unidadeData;
        listarArea();
      }
    );

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      emitir.value.unidade = store.state.org.unidadeData;
      modalArea.value.unidade = store.state.org.unidadeData;
      listarArea();
    };

    onMounted(getUnidade);

    let criar = async () => {
      if (modalArea.value.nome == "") {
        $q.notify({
          message: "Digite o nome da Área",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
        return;
      }

      try {
        await store.dispatch("area/criar", {
          unidadeId: modalArea.value.unidade.id,
          nome: modalArea.value.nome,
        });

        $q.notify({
          message: "Área Cadastrada",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
        reset();
        onReset();
        rightDrawerOpen.value = false;
        listarArea();
      } catch (e) {
        if (e.request.status < 500) {
          for (let index in e.response.data.errors) {
            $q.notify({
              message: e.response.data.errors[index],
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        }

        if (e.request.status >= 500) {
          $q.notify({
            message: "Erro no servidor, tente novamente",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const onReset = async () => {
      await reset();
      myForm.value.resetValidation();
    };

    const reset = async () => {
      modalArea.value = {
        unidade: modalArea.value.unidade,
        nome: "",
      };
    };

    const removerArea = async (resultado) => {
      confirmacao.value = false;
      if (resultado) {
        try {
          await store.dispatch("area/excluirArea", {
            unidadeId: emitir.value.unidade.id,
            areaId: deteleId.value,
          });
          $q.notify({
            message: "Área removida com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          listarArea();
        } catch (error) {
          console.log(error);
          $q.notify({
            message: "Erro ao remover área",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    return {
      area,
      modalArea,
      rightDrawerOpen,
      criar,
      myForm,
      listaArea,
      listarArea,
      columns,
      emitir,
      getUnidade,
      disable,
      removerArea,
      confirmacao,
      deteleId,
      temPermissaoTodasUnidades,
      modalSelecioneUnidade,
      abrirModalCriar,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.texto-titulo-input {
  font-size: 14px;
  color: #21324a;
  font-weight: bold;
  margin-bottom: 4px;
}
.btn-modal {
  background-color: #21324a;
  border-radius: 8px;
  color: white;
}
</style>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}

.mascara {
  background-color: black;
  height: 100% !important;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}

@media (max-width: 600px) {
  .col-md-12.col-sm-12.col-xs-12.q-mt-sm {
    margin-top: 8px !important;
  }

  .col-md-12.col-sm-12.col-xs-12.q-mt-sm:first-child {
    margin-top: 0 !important;
  }
}

@media (max-width: 480px) {
  .col-md-12.col-sm-12.col-xs-12.q-mt-sm {
    margin-top: 6px !important;
  }

  .col-md-12.col-sm-12.col-xs-12.q-mt-sm:first-child {
    margin-top: 0 !important;
  }
}

@media (max-width: 360px) {
  .col-md-12.col-sm-12.col-xs-12.q-mt-sm {
    margin-top: 4px !important;
  }

  .col-md-12.col-sm-12.col-xs-12.q-mt-sm:first-child {
    margin-top: 0 !important;
  }
}
</style>
